<template>
  <pbc-modal ref='modal' @close="close" :disable-title="true">
    <template #default="{}">
      <div class="flex flex-col h-full">
        <div class="m-auto text-grey-700 text-sm font-semibold w-full bg-white">Add New</div>
        <add-transform-wizard ref='addTransformWizard' 
          class="grow"
          :adding-to-parents="addingToParents"
          :adding-to-children-components='addingToChildrenComponents'
          :partutil="partutil"
          :transforms-and-source="transformsAndSource"
          :skip-funky='skipFunky'
          @next='next'
          @add-children="addChildren"
          @select-children='selectChildren'
          @position-children='positionChildre'
          @validate-step='onValidateStep'
          @validated-component-setup='(nv) => { validatedSetup = nv }'
          @change-step='changeStep' />
      </div>

    </template>
    <template #controls="{}">
      <div class="mx-2 mb-2 pt-2 flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click="close">
          <close class="mx-2"/>
          <span class="mr-2">Cancel</span>
        </pbc-button>
        <pbc-button v-if='currentStep < (numSteps - 1)' :disabled='!nextEnabled' @click="next" class="bg-blue-400" :class='nextEnabled ? "animate-next" : ""'>
          <chevron-right class="mx-1"/>
          <span class="mr-2">Next</span>
        </pbc-button>
        <pbc-button v-if='currentStep === (numSteps-1)' :disabled='!nextEnabled' @click="done" class="bg-blue-400 animate-next">
          <check class="mx-1"/>
          <span class="mr-2">Done</span>
        </pbc-button>
      </div>
    </template>
  </pbc-modal>
  
</template>
<script>
import AddTransformWizard from './AddTransformWizard.vue';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
import ChevronRight from '@icons/ChevronRight.vue';

export default {
  props: {
    addingToParents: {
      type: Array,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    addingToChildrenComponents: {
      type: Array,
      required: true
    },
    skipFunky: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: 0,
      nextEnabled: false,
      numSteps: 0
    }
  },
  components: {
    Check,
    Close,
    ChevronRight,
    AddTransformWizard
  },
  mounted() {
    this.$ana.track({
      eventCategory: 'ui',
      eventAction: 'addTransformWizard'
    });
  },
  methods: {
    onValidateStep(nv) {
      this.nextEnabled = nv;
    },
    next() {
      console.log('next', this.currentStep, 'numSteps', this.numSteps);
      if (this.currentStep == this.numSteps - 1) {
        console.log('is done?!?!?!?');
        this.done();
      } else {
        this.$ana.track({
          eventCategory: 'ui',
          eventAction: 'stepAddTransformWizardDialog'
        });

        this.$refs.addTransformWizard.next(this.currentStep + 1);
      }
      //this.$refs.addTransformWizard.selectStep(this.currentStep + 1);
    },
    done() {
      this.$refs.addTransformWizard.done();
      this.$refs.modal.close(true);
      this.$emit("close");
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'doneAddTransformWizardDialog'
      });
    },
    close() {
      this.$refs.addTransformWizard.undo();
      this.$refs.modal.close(true);
      this.$emit("close");
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'cancelAddTransformWizardDialog'
      });
    },
    addChildren(o) {
      this.$emit('add-children', o);
    },
    selectChildren(o) {
      console.log('here but why', o);
      this.$emit('select-children', o);
    },
    positionChildre(o) {
      this.$emit('position-children', o);
    },
    changeStep(newStep, numSteps) {
      console.log('change step', newStep, 'numSteps', numSteps);
      this.currentStep = newStep;
      this.numSteps = numSteps;
    }
  }
}
</script>
<style>
.animate-next {
 @apply transition duration-500 ease-in-out transform scale-110;
}
</style>
